// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3gQQF","checkboxCol":"Table_checkboxCol__OvUQR","emailCol":"Table_emailCol__2ehUz","actionCol":"Table_actionCol__3Qd1O"};